const eventBus = new EventTarget();
export default eventBus;
